export enum TipoAmbiente {
    LOCAL = 'LOCAL',
    NUVEM = 'NUVEM',
}
